import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import NoMoreDebtTodayWrapper from "@components/layouts/noMoreDebtTodayWrapper";
import { useDomainContext } from "@hooks/useDomainContext";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function PrivacyPolicyHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <NoMoreDebtTodayWrapper boxShadow="0px -2px 10px #888888">
            <PrivacyPolicy
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </NoMoreDebtTodayWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
